// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bek_a bib_b bib_va bib_rv bib_rw bib_vu","PanelFooter--link":"bek_b"};